// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__25h97","rootSuccess":"CompleteLink_rootSuccess__egBJ8","rootFailure":"CompleteLink_rootFailure__3EpGs","isDisabled":"CompleteLink_isDisabled__3Vp7l"};